import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

//Material UI
import {
  Alert,
  Box,
  Button,
  ButtonGroup,
  Collapse,
  Container,
  CssBaseline,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

//Fetch
import API from "../../utils/API";
import {
  ChevronLeft,
  VisibilityOffOutlined,
  VisibilityOutlined,
} from "@mui/icons-material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";

import { LoadingButton } from "@mui/lab";

function ForgotPassword() {
  const navigate = useNavigate();

  const [forgotType, setForgotType] = useState("phone");
  const [phone, setPhone] = useState();
  const [password, setPassword] = useState();
  const [confirmpassword, setConfirmPassword] = useState();
  const [passwordMismatch, setPasswordMismatch] = useState(false);
  const [otp, setOtp] = useState();
  const [otpInput, setOtpInput] = useState();
  const [timer, setTimer] = useState(60);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [step, setStep] = useState(1);

  const handleSendOTP = async () => {
    setTimer(60);
    if (forgotType === "phone" && phone.length !== 11) {
      return alert("Phone number must be 11 digits.");
    }
    try {
      setLoading(true);
      const res = await API({
        method: "POST",
        url: "forget/",
        requestConfig: {
          phone: forgotType === "phone" ? phone : undefined,
          email: forgotType === "email" ? phone : undefined,
        },
      });
      setStep(2);
      setOtp(res.otp);
      let time = 60;
      const interval = setInterval(() => {
        time--;
        setTimer(time);
        if (time === 0) {
          clearInterval(interval);
        }
      }, 1000);
    } catch (error) {
      if (error.message === "Request failed with status code 400") {
        alert(
          "Error",
          "Phone number does not exist, please register your account."
        );
      } else {
        alert("Error", "An Error Occured");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmOTP = async () => {
    if (otpInput === otp.toString()) {
      setStep(3);
    } else {
      alert("OTP does not match");
    }
  };

  const handleChangePassword = async () => {
    if (password !== confirmpassword) {
      setPasswordMismatch(true);
      return;
    }
    try {
      setLoading(true);
      const res = await API({
        method: "POST",
        url: "setpassword/",
        requestConfig: {
          username: phone,
          new_password: password,
          confirm_password: confirmpassword,
        },
      });
      alert("Password Changed Successfully");
      navigate("/account/signin");
    } catch (error) {
      console.log(error);
      alert("An Error Occured");
    } finally {
      setLoading(true);
    }
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{ display: "flex", height: "100vh", alignItems: "center" }}
    >
      <CssBaseline />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fff",
          padding: 4,
          borderRadius: 5,
          textAlign: "left",
        }}
      >
        <Box>
          <IconButton
            color="primary"
            onClick={() => navigate("/account/signin")}
          >
            <KeyboardBackspaceIcon color="primary" />
          </IconButton>
        </Box>
        {/* <Typography fontWeight="bold" variant="h5" >Forgot Password</Typography> */}
        {step === 1 && (
          <>
            <ButtonGroup
              fullWidth
              sx={{
                my: 2,
              }}
            >
              <Button
                variant={forgotType === "phone" ? "contained" : "outlined"}
                onClick={() => setForgotType("phone")}
              >
                Phone
              </Button>
              <Button
                variant={forgotType === "email" ? "contained" : "outlined"}
                onClick={() => setForgotType("email")}
              >
                Email
              </Button>
            </ButtonGroup>
            <Typography component="h4" variant="h6" fontWeight={"bold"}>
              Verify {forgotType === "email" ? "Email" : "Phone"}
            </Typography>
            <Typography>
              Please enter your phone number to receive a 6-digit OTP.
            </Typography>
            <Stack spacing={2} sx={{ mt: 3 }}>
              <TextField
                label={forgotType === "email" ? "Email" : "Phone"}
                fullWidth
                type={forgotType === "email" ? "email" : "phone"}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <LoadingButton
                loading={loading}
                variant="contained"
                onClick={handleSendOTP}
              >
                Confirm
              </LoadingButton>
            </Stack>
          </>
        )}
        {step === 2 && (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <IconButton color="primary" onClick={() => setStep(1)}>
                <ChevronLeft />
              </IconButton>
            </Box>
            <Stack
              spacing={2}
              sx={{ mt: 2, display: "flex", flexDirection: "column" }}
            >
              <Typography component="h4" variant="h5" fontWeight={"bold"}>
                Enter OTP
              </Typography>
              <Typography>
                Please enter the 6-digit PIN Code sent to {phone}.
              </Typography>
            </Stack>
            <Stack spacing={2} sx={{ mt: 3 }}>
              <TextField
                label="OTP"
                fullWidth
                value={otpInput}
                onChange={(e) => setOtpInput(e.target.value)}
              />
              <Typography>Resend OTP in {timer} seconds</Typography>
              {timer === 0 && (
                <Button variant="contained" onClick={handleSendOTP}>
                  Resend
                </Button>
              )}
              <Button variant="contained" onClick={handleConfirmOTP}>
                Confirm
              </Button>
            </Stack>
          </>
        )}
        {step === 3 && (
          <>
            <Stack spacing={2}>
              <Typography component="h3" variant="h5" fontWeight={"bold"}>
                Create Password
              </Typography>
              <Typography>
                Create a new password for your account. You will use this
                password to login to your account.
              </Typography>
              <Stack spacing={2} sx={{ mt: 3 }}>
                <Box
                  sx={{
                    position: "relative",
                  }}
                >
                  <TextField
                    label="New Password"
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    sx={{ position: "absolute", right: 5, bottom: 8 }}
                  >
                    {showPassword ? (
                      <VisibilityOutlined />
                    ) : (
                      <VisibilityOffOutlined />
                    )}
                  </IconButton>
                </Box>
                <Box
                  sx={{
                    position: "relative",
                  }}
                >
                  <TextField
                    label="Confirm Password"
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    value={confirmpassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <IconButton
                    onClick={() => setShowPassword(!showPassword)}
                    sx={{ position: "absolute", right: 5, bottom: 8 }}
                  >
                    {showPassword ? (
                      <VisibilityOutlined />
                    ) : (
                      <VisibilityOffOutlined />
                    )}
                  </IconButton>
                </Box>
                <Collapse in={passwordMismatch}>
                  <Alert
                    onClose={() => setPasswordMismatch(false)}
                    severity="error"
                  >
                    Password Doesn't Match
                  </Alert>
                </Collapse>
                <LoadingButton
                  loading={loading}
                  variant="contained"
                  onClick={handleChangePassword}
                >
                  Confirm
                </LoadingButton>
              </Stack>
            </Stack>
          </>
        )}
      </Box>
    </Container>
  );
}

export default ForgotPassword;
